import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { DiveListItem } from "@/lib/database";
import type { DiveMetadata } from "@/lib/metadata";

interface DiveListItemWithMetadata extends DiveListItem {
  metadata: DiveMetadata | null;
}

interface DiveSelectorProps {
  dives: DiveListItemWithMetadata[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}

export function DiveSelector({ dives, selectedId, onSelect }: DiveSelectorProps) {
  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
  };

  const getDiveName = (dive: DiveListItemWithMetadata) => {
    return dive.metadata?.customName || `Dive #${dive.diveNumber}`;
  };

  const formatDiveLabel = (dive: DiveListItemWithMetadata) => {
    return `${formatDate(dive.date)} - ${getDiveName(dive)}`;
  };

  return (
    <Select value={selectedId || undefined} onValueChange={onSelect}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Select a dive" />
      </SelectTrigger>
      <SelectContent>
        {dives.map((dive) => (
          <SelectItem key={dive.id} value={dive.id}>
            {formatDiveLabel(dive)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
